<template>
  <div class="homework-details">
    <h2>Praca domowa</h2>

    <div class="homework-details__item-wrapper">
      <img class="homework-details__item-icon" aria-hidden="true" alt="" src="~@/assets/images/icons/i_lightbulb.svg" />
      <div class="homework-details__item-content">
        <span class="homework-details__item-title">Temat</span>
        <p class="homework-details__item-description" v-html="linkify(subject)"></p>
      </div>
    </div>

    <div class="homework-details__item-wrapper">
      <img class="homework-details__item-icon" aria-hidden="true" alt="" src="~@/assets/images/icons/i_calendar.svg" />
      <div class="homework-details__item-content">
        <span class="homework-details__item-title">Termin oddania</span>
        <p class="homework-details__item-description">{{ dueDate }}</p>
      </div>
    </div>

    <div class="homework-details__item-wrapper">
      <img class="homework-details__item-icon" aria-hidden="true" alt="" src="~@/assets/images/icons/i_check.svg" />
      <div class="homework-details__item-content">
        <span class="homework-details__item-title">Status</span>
        <div class="homework-details__item-tag">
          <HomeworkStatusPill :status="formattedStatus" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex';
import DOMPurify from 'dompurify';
import HomeworkStatusPill from './HomeworkStatusPill.vue';

export default {
  name: 'HomeworkSummaryDetails',
  props: {
    subject: {
      type: String,
      default: '',
    },
    dueDate: {
      type: String,
      default: '',
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  components: {
    HomeworkStatusPill,
  },
  computed: {
    ...mapState('students', ['student']),
    formattedStatus() {
      const statusMap = {
        0: 'not-checked',
        undefined: 'not-checked',
        1: 'checked',
        2: 'partly-checked',
        3: 'unfinished',
      };
      return statusMap[this.status] || 'not-checked';
    },
  },
  methods: {
    ...mapActions('uploadedHomeworks', [
      'updatedGetUploadedHomeworks',
      'updatedUploadHomeworks',
    ]),
    linkify(text) {
      if (!text) return '';

      // eslint-disable-next-line no-useless-escape
      const urlPattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      // eslint-disable-next-line no-useless-escape
      const wwwPattern = /(^|[^\/])(www\.[\S]+(\b|$))/ig;
      // eslint-disable-next-line no-useless-escape
      const mailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/ig;

      const linkedText = text
        .replace(urlPattern, '<a class="homework-details__item-description-link esc-link" href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
        .replace(wwwPattern, '$1<a class="homework-details__item-description-link esc-link" href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>')
        .replace(mailPattern, '<a class="homework-details__item-description-link esc-link" href="mailto:$1">$1</a>');

      return DOMPurify.sanitize(linkedText, { ALLOWED_TAGS: ['a'], ALLOWED_ATTR: ['href', 'target', 'rel', 'class'] });
    },
  },

};
</script>

<style lang="scss" scoped>
.homework-details {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__item-wrapper {
    display: flex;
    gap: 12px
  }

  &__item-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__item-icon {
    width: 24px;
    height: 24px;
  }

  &__item-title {
    color: var(--grey-900, #111724);
    font-family: "GT Walsheim Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  &__item-description {
    color: var(--grey-900, #111724);
    font-family: "GT Walsheim Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
}

:global(.homework-details__item-description-link) {
  font-family: "GT Walsheim Pro";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
</style>
